module.exports = __webpack_public_path__ + "static/media/logo-신세계@3x.aaede5f0.png";